import request from '../utils/request';

/**
 * 获取用户认证信息分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getVerificationList = (params) => {
    console.log(params);
  return request({
    url: '/user/verification/list',
    method: 'get',
    params
  });
};

/**
 * 获取用户认证详情
 * @param {number} id 认证ID
 * @returns {Promise} 请求结果
 */
export const getVerificationDetail = (id) => {
  return request({
    url: `/user/verification/${id}`,
    method: 'get'
  });
};

/**
 * 审核用户认证
 * @param {number} id 认证ID
 * @param {Object} data 审核数据
 * @returns {Promise} 请求结果
 */
export const auditVerification = (id, data) => {
  return request({
    url: `/user/verification/${id}/audit`,
    method: 'put',
    data
  });
}; 